export default function systemPlugin(store) {
  const updateOnlineStatus = () => {
    store.commit('system/setOnline', navigator.onLine);
  };

  window.addEventListener('online', updateOnlineStatus);
  window.addEventListener('offline', updateOnlineStatus);
  updateOnlineStatus();

  setTimeout(() => {
    const vm = store._vm;
    const isMobile = vm?.$vuetify?.breakpoint?.mobile ?? false;
    store.commit('system/setMobile', isMobile);
  }, 100);
}
